export interface Image {
  userId: string
  fileName: string
  cover: boolean
  size: number
  status: number
  url: string
}

export type AlbumType = 'announce' | 'event' | 'jobOffer'

export const ALBUM_STATUS = {
  announce: 1,
  event: 2,
  jobOffer: 3,
} as const

export const isImageInAlbum = (
  status: number,
  albumType: AlbumType,
): boolean => {
  if (status === 0) return false
  const statusStr = status.toString()
  const albumValue = ALBUM_STATUS[albumType].toString()
  return statusStr.includes(albumValue)
}

export const removeFromAlbum = (
  status: number,
  albumType: AlbumType,
): number => {
  if (status === 0) return 0

  const statusStr = status.toString()
  const albumValue = ALBUM_STATUS[albumType].toString()

  const newStatusStr = statusStr.replace(albumValue, '')

  if (newStatusStr === '') return 0

  return parseInt(newStatusStr)
}

export const addToAlbum = (status: number, albumType: AlbumType): number => {
  const albumValue = ALBUM_STATUS[albumType]

  if (isImageInAlbum(status, albumType)) return status

  if (status === 0) return albumValue

  return parseInt(status.toString() + albumValue.toString())
}
